webpackJsonp([17],{

/***/ 189:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

angular.module('appMarketplace')
    .directive('about', ['UrlService', 'NotificationService', 'HelpService', 'CommonService', '$compile', '$templateCache',
                        '$http',
                        function (UrlService, NotificationService, HelpService, CommonService, $compile, $templateCache,
                                  $http) {
        return {
            restrict: 'A',
            scope: {
                versionInfo: '@'
            },
            link: function (scope, element, attrs) {
                var window;

                element.on('click', function clickHandler() {
                    if (window && window.element.length) {
                        return;
                    }

                    $http.get(UrlService.createAbsoluteUrl('/js/main/directives/templates/about-template.html?ver=31d283f53c6f5b2f6f2c499914ce24b7'), {cache: $templateCache})
                        .then(function successCallback(response) {
                            HelpService.getVersionInfo(function successCallback(data) {
                                scope.versionInfo = data;
                                var templateElement = angular.element(response.data);
                                var windowElement = $compile(templateElement.filter(".about-template").html())(scope);
                                var position = {
                                    top: element.offset().top,
                                    left: element.offset().left
                                };
                                window = windowElement.kendoWindow({
                                    title: "About",
                                    width: 350,
                                    maxHeight: 250,
                                    visible: false,
                                    resizable: false,
                                    deactivate: function () {
                                        this.destroy();
                                    }
                                }).data("kendoWindow").openInPosition(position);
                            }, function errorCallback(responseError) {
                                NotificationService.showErrorMessage(responseError);
                            });
                        }, NotificationService.showValidationErrors);
                });
            }
        };
    }]);

/***/ }),

/***/ 201:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

angular.module('appMarketplace')
    .directive('feedback', ['NavigationService', 'UrlService', 'NotificationService', 'CommonService', '$compile',
                            '$templateCache', '$http', 'HelpService',
                            function (NavigationService, UrlService, NotificationService, CommonService, $compile,
                                      $templateCache, $http, HelpService) {
        return {
            restrict: 'A',
            link: function (scope, element, attrs) {
                var window;

                function resetItem() {
                    scope.subject = '';
                    scope.comments = '';
                }

                element.on('click', function clickHandler() {
                    if (window && window.element.length) {
                        return;
                    }

                    resetItem();

                    NavigationService.getCurrentAccount(function (currentAccount) {
                        scope.currentAccount = currentAccount;
                        $http.get(UrlService.createAbsoluteUrl('/js/main/directives/templates/feedback-template.html?ver=dd94473cec7c4d1067f4875b352a7c20'), {cache: $templateCache})
                            .then(function successCallback(response) {
                                var templateElement = angular.element(response.data);
                                var windowElement = $compile(templateElement.filter(".feedback-template").html())(scope);
                                var position = {
                                    top: element.offset().top,
                                    left: element.offset().left
                                };
                                window = windowElement.kendoWindow({
                                    title: "Feedback",
                                    width: 350,
                                    maxHeight: 375,
                                    visible: false,
                                    resizable: false,
                                    deactivate: function () {
                                        this.destroy();
                                    }
                                }).data("kendoWindow").openInPosition(position);

                                var formErrorTemplate = kendo.template(templateElement.filter("#feedbackFormErrorTemplate").html());
                                scope.validator = windowElement.kendoValidator({
                                    errorTemplate: formErrorTemplate,
                                    messages: {
                                        required: "Field is required"
                                    }
                                }).data("kendoValidator");

                                scope.sendFeedback = function () {
                                    if (!scope.validator.validate()) {
                                        return;
                                    }
                                    CommonService.showProgressPanel(windowElement, false);

                                    HelpService.sendFeedback({
                                        subject: scope.subject,
                                        comments: scope.comments
                                    }, function feedbackSentSuccessful() {
                                        CommonService.hideProgressPanel(windowElement);
                                        NotificationService.showSuccessMessage('Successfully sent feedback');
                                        window.close();
                                    }, function errorCallback(responseError) {
                                        CommonService.hideProgressPanel(windowElement);
                                        var validationErrors = responseError.validationErrors;
                                        if (validationErrors && Object.keys(validationErrors).length) {
                                            CommonService.displayValidationErrors(validationErrors, formErrorTemplate, windowElement);
                                        } else {
                                            NotificationService.showErrorMessage(responseError.message);
                                        }
                                    });
                                }
                            }, NotificationService.showValidationErrors);
                    });
                });
            }
        };
    }]);

/***/ }),

/***/ 205:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

angular.module('appMarketplace')
    .controller('AccountCtrl', ['$scope', '$location', 'NavigationService', function ($scope, $location, NavigationService) {
        function updateSkipLink() {
            var currentUrl = $location.absUrl();
            var hash = $location.hash();
            if (hash) {
                currentUrl = currentUrl.replace("#" + hash, "");
            }
            $scope.skipLink = currentUrl + "#main-content";
        }

        updateSkipLink();

        NavigationService.getCurrentAccount(function successCallback(currentAccount) {
            $scope.currentAccount = currentAccount;
        });
    }]);


/***/ }),

/***/ 236:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

angular.module('appMarketplace')
    .controller('HeaderCtrl', ['$scope', '$state', '$timeout', '$filter', 'UrlService', 'NavigationService', 'navigationStyle',
                              'CommonService', 'UserService',
                              function ($scope, $state, $timeout, $filter, UrlService, NavigationService, navigationStyle,
                                        CommonService, UserService) {
        var PAGES_WITH_DOCUMENT_ID = [
            '/catalogue-search.html',
            '/punch-out-suppliers.html',
            '/supplier-directory.html',
            '/quick-add.html'
        ];
        var CATALOGUE_GROUP_ID = 2;
        var DELTA = 50;
        var MIN_WINDOW_WIDTH = 600;
        
        $scope.documentId = UrlService.getURLParameter('DocumentId');

        var mainMenuWrapper;
        var collapsedMenuWrapper;
        var menu = angular.element('#menuHeaderContainer');

        function initMenu() {
            mainMenuWrapper = function () {
                var element = angular.element("#mainMenu");
                return {
                    makeVisible: function () {
                        element.css("visibility", "visible");
                    },
                    getVisibleItems: function () {
                        return element.find("> li:visible");
                    },
                    getHiddenItems: function () {
                        return element.find("> li.k-item:hidden");
                    }
                };
            }();

            collapsedMenuWrapper = function () {
                var element = angular.element("#collapsedMenu");
                return {
                    element: element,
                    makeVisible: function () {
                        element.css("visibility", "visible");
                    },
                    show: function () {
                        element.css("display", "inline-block");
                    },
                    hide: function () {
                        element.hide();
                    },
                    getVisibleItems: function () {
                        return element.find("li.k-item.nav-group:not(.hidden-item)");
                    },
                    getHiddenItems: function () {
                        return element.find("li.k-item.hidden-item");
                    },
                    showLastHiddenItem: function () {
                        this.getHiddenItems().last().toggleClass("hidden-item");
                    }
                };
            }();
            collapsedMenuWrapper.element.find("> li > ul > li.k-item").toggleClass('hidden-item'); //hide all items
            resizeMenu();
            mainMenuWrapper.makeVisible();
            collapsedMenuWrapper.makeVisible();
        }

        CommonService.showProgressPanel(menu, false);
        NavigationService.getNavigationData(function successCallback(value) {
            changeUrl(value);    // works for PAGES_WITH_DOCUMENT_ID when came from order variation

            var collapsedGroupsTitle = "More";
            var collapsedGroups = {
                text: '<span class="' + navigationStyle[collapsedGroupsTitle] + ' nav-group-icon"></span>' + collapsedGroupsTitle,
                items: value,
                encoded: false
            };

            $scope.mainMenuDS = value;
            onMenuInitialized('mainMenu');

            $scope.collapsedMenuDS = collapsedGroups;
            onMenuInitialized('collapsedMenu');

            CommonService.hideProgressPanel(menu);
            $timeout(initMenu);
        });

        function changeUrl(value) {
            angular.forEach(PAGES_WITH_DOCUMENT_ID, function pagesIterator(page) {
                if (UrlService.checkUrlContains(page) && $scope.documentId) {
                    changePagesUrl(value);
                }
            });
        }

        function changePagesUrl(value) {
            angular.forEach(value, function menuIterator(group) {
                if (group.id === CATALOGUE_GROUP_ID) {
                    angular.forEach(group.items, function groupIterator(item) {
                        if (PAGES_WITH_DOCUMENT_ID.some(function urlContainsPage(page) {
                                return item.url.indexOf(page) !== -1;
                            })) {
                            item.url += '?DocumentId=' + $scope.documentId;
                        }
                    })
                }
            })
        }

        $scope.getBasketTooltipMessage = function (basketSize, basketNetTotal) {
            return basketSize
                + " item"
                + (basketSize === 1 ? "" : "s")
                + " - "
                + $filter('currency')(basketNetTotal.value, basketNetTotal.currency.currencySymbol, 2);
        };

        $scope.logoutUrl = UrlService.createAbsoluteUrl('/useradmin/logout.jsp');

        UserService.showRequiredFormIfAnyNeeded();

        NavigationService.getCurrentAccount(function successCallback(currentAccount) {
            $scope.currentAccount = currentAccount;

            $scope.isBasketAvailable = currentAccount.basketAvailable;
            if ($scope.isBasketAvailable) {
                $scope.basketUrl = UrlService.createAbsoluteUrl('/page/basket.html');
                $scope.basketTooltip = kendo.template(angular.element("#basketTooltipTemplate").html());
            }

            $scope.isSavedBasketsAvailable = currentAccount.savedBasketsAvailable;
            if ($scope.isSavedBasketsAvailable) {
                $scope.savedBasketsUrl = UrlService.createAbsoluteUrl('/page/basket/saved-baskets.html');
            }

            $scope.userAccountMenuDS = NavigationService.getUserAccountMenu(currentAccount);
            onMenuInitialized('userAccountMenu');

            $scope.helpMenuDS = NavigationService.getHelpMenu(currentAccount);
            onMenuInitialized('helpMenu');
        });

        $scope.quickLinksMenuDS = NavigationService.getQuickLinksMenu();
        onMenuInitialized('quickLinksMenu');

        $scope.selectMenu = function(e) {
            if(angular.element(e.item).attr("openInNewWindow") === 'true') {
                e.preventDefault();
                window.open(angular.element(e.item).find("a").attr("href"), '_blank');
            }
        };

        function getWrappersDistance() {
            var navigationWrapper = angular.element("#navigationWrapper");
            var navigationRightEdgeX = navigationWrapper.offset().left + navigationWrapper.width(); //should be zero + width
            var actionsWrapper = angular.element("#actionsWrapper");
            return actionsWrapper.offset().left - navigationRightEdgeX;
        }

        function collapseMenu() {
            mainMenuWrapper.getVisibleItems().last().hide();
            collapsedMenuWrapper.show();
            collapsedMenuWrapper.showLastHiddenItem();
        }

        function expandMenu() {
            mainMenuWrapper.getHiddenItems().first().show();
            var visibleCollapsedItems = collapsedMenuWrapper.getVisibleItems();
            visibleCollapsedItems.first().toggleClass("hidden-item");
            if (visibleCollapsedItems.length <= 1) {
                collapsedMenuWrapper.hide();
            }
        }

        function collapseNeeded() {
            return window.innerWidth > MIN_WINDOW_WIDTH && getWrappersDistance() < DELTA;
        }

        function expandNeeded() {
            return mainMenuWrapper.getHiddenItems().length
                    && (getWrappersDistance() - mainMenuWrapper.getHiddenItems().last().width() >= DELTA);
        }

        function resizeMenu() {
            if (mainMenuWrapper) {
                while (collapseNeeded()) {
                    collapseMenu();
                }

                while (expandNeeded()) {
                    expandMenu();
                }
            }
        }

        function onMenuInitialized(menuName) {
            $timeout(function () {
                $scope.$emit('domChanged', $scope[menuName].element);
            });
        }

        function closeMenu(menu) {
            if (menu) {
                menu.close(".k-item");
            }
        }

        angular.element(document).on('mouseleave', function onMouseLeave() {
            closeMenu($scope.mainMenu);
            closeMenu($scope.collapsedMenu);
            closeMenu($scope.userAccountMenu);
            closeMenu($scope.helpMenu);
            closeMenu($scope.quickLinksMenu);
        });

        var resizeTimer;
        angular.element(window).on('resize', function onResize() {
            $timeout.cancel(resizeTimer);
            resizeTimer = $timeout(resizeMenu, 100);
        });
    }]);


/***/ }),

/***/ 269:
/***/ (function(module, exports) {

angular.module('appMarketplace')
    .service('HelpService', ['$http', 'UrlService', function ($http, UrlService) {
        var service = this;

        service.getVersionInfo = function (successCallback, errorCallback) {
            var req = {
                method: 'GET',
                url: UrlService.createAbsoluteUrl('/rest/help/versionInfo'),
                cache: true
            };

            $http(req).then(function successCallbackWrapper(response) {
                successCallback(response.data);
            }, function errorCallbackWrapper(error) {
                errorCallback(error)
            })
        };

        service.sendFeedback = function (feedback, successCallback, errorCallback) {
            var req = {
                method: 'POST',
                url: UrlService.createAbsoluteUrl('/rest/currentAccount/feedback'),
                data: feedback
            };

            $http(req).then(successCallback,
                function errorCallbackWrapper(response) {
                    errorCallback(response.data)
                })
        };

        service.getReleasePageUrl = function () {
            return UrlService.createAbsoluteUrl('/release.jsp');
        }
    }]);

/***/ }),

/***/ 272:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

angular.module('appMarketplace')
    .service('NavigationService', ['$http', '$window', 'UrlService', 'navigationStyle', 'dataAttributes',
        'NotificationService', 'CommonService', '$state',
        function ($http, $window, UrlService, navigationStyle, dataAttributes, NotificationService,
                  CommonService, $state) {
            var service = this;

            service.capitalize = function capitalize(line) {
                if (line) {
                    var firstLetter = line.charAt(0).toUpperCase();
                    line = firstLetter + (line.length > 1 ? line.slice(1) : '');
                }
                return line;
            };

            service.produceMenuGroup = function (group) {
                return {
                    id: group.id,
                    text: '<span id="menu-' + group.id + '" class="' + navigationStyle[group.name] + ' nav-group-icon" ' +
                            dataAttributes[group.name] + '></span>' + service.capitalize(group.name),
                    encoded: false,
                    cssClass: "nav-group"
                };
            };

            service.getNavigationDataSuccessCallback = function (response, successCallback) {
                var data = response.data;
                var navigationGroups = [];
                angular.forEach(data, function iterator(group) {
                    var menuGroupItem;
                    if (group.name === 'home') {
                        var homeItem = group.items[0];
                        menuGroupItem = service.produceMenuGroup(group);
                        menuGroupItem.url = UrlService.createAbsoluteUrl(homeItem.url);
                        navigationGroups.push(menuGroupItem);
                    } else {
                        var navigationItems = [];
                        angular.forEach(group.items, function iterator(item) {
                            var url = UrlService.createAbsoluteUrl(item.url);
                            navigationItems.push({
                                text: '<span id="subMenu-' + item.id + '"></span>' +
                                    service.capitalize(item.name),
                                url: url,
                                encoded: false
                            });
                        });
                        menuGroupItem = service.produceMenuGroup(group);
                        menuGroupItem.items = navigationItems;
                        navigationGroups.push(menuGroupItem);
                    }
                });
                successCallback(navigationGroups);
            };

            service.getNavigationData = function getNavigationData(successCallback) {
                var req = {
                    method: 'GET',
                    url: UrlService.createAbsoluteUrl('/rest/currentAccount/navigation')
                };
                $http(req)
                    .then(function successCallbackWrapper(response) {
                        service.getNavigationDataSuccessCallback(response, successCallback);
                    }, NotificationService.showValidationErrors);
            };

            service.fillMenuItems = function (menuItems, account) {
                angular.forEach(account.accountMenu, function (item) {
                    var itemUrl = item.url;
                    var url = null;
                    var select = null;
                    if (itemUrl === 'update-password.html') {
                        select = function onItemSelect() {
                            $state.go('update-password-state', {manualUpdate: true}, {location: false});
                        }
                    } else if (itemUrl === 'update-password-hint.html') {
                        select = function onItemSelect() {
                            $state.go('update-password-hint-state', {manualUpdate: true}, {location: false});
                        }
                    } else {
                        url = UrlService.createAbsoluteUrl(itemUrl);
                    }
                    menuItems.push({
                        text: service.capitalize(item.name),
                        url: url,
                        select: select,
                        encoded: false
                    });
                });
            };

            service.getUserAccountMenu = function getUserAccountOptions(account) {
                var accountsToSwitch;
                if (account.availableAccounts) {
                    accountsToSwitch = [];
                    angular.forEach(account.availableAccounts, function (account) {
                        accountsToSwitch.push({
                            text: account.name,
                            select: function switchAccount() {
                                $http.post(UrlService.createAbsoluteUrl('/rest/currentAccount/' + account.id + '/switch')).then(
                                    function successfulCallback() {
                                        $window.location.reload();
                                    },
                                    function errorCallback() {
                                        NotificationService.showErrorMessage("Cannot switch account to '" + account.name + "'");
                                    }
                                );
                            }
                        });
                    });
                }

                function closeOnSelect(e) {
                    e.sender.close();
                }

                var userAccountOptions = {
                    text: '<span id="useInfo" class="glyphicons glyphicons-user menu-action" title="User account menu"></span>',
                    encoded: false,
                    items: [
                        {
                            text: CommonService.escapeHtml(account.name) + '<br>' +
                                CommonService.escapeHtml(account.orgUnitName) + '<br>' +
                                CommonService.escapeHtml(account.environmentName),
                            encoded: false,
                            cssClass: 'user-name',
                            items: accountsToSwitch
                        }, {
                            text: '',
                            cssClass: 'k-separator'
                        }
                    ]
                };

                var menuItems = userAccountOptions.items;
                service.fillMenuItems(menuItems, account);

                return userAccountOptions;
            };

            service.getResolvedCurrentAccount = function getResolvedCurrentAccount(resolvedCallback, notResolvedCallback) {
                if (service.currentAccountPromise && service.currentAccountPromise.resolved) {
                    service.getCurrentAccount(function setAccount(data) {
                        resolvedCallback(data);
                    });
                } else {
                    notResolvedCallback();
                }
            };

            service.fillHelpMenuItems = function (menuItems, account) {
                angular.forEach(account.helpMenu, function (item) {
                    var itemUrl = item.url;
                    var url = null;
                    var attr = null;
                    if (itemUrl === 'about.html') {
                        attr = 'about'; // add it as angular attribute
                    } else {
                        url = UrlService.createAbsoluteUrl(itemUrl);
                    }

                    var attrs = {
                        openInNewWindow: UrlService.isAbsoluteUrl(itemUrl)
                    };
                    if (attr) {
                        attrs[attr] = attr;
                    }

                    menuItems.push({
                        spriteCssClass: determineFileTypeIcon(item.type),
                        text: service.capitalize(item.name),
                        url: url,
                        encoded: false,
                        attr: attrs
                    });
                });
            };

            service.getHelpMenu = function getHelpOptions(account) {
                var menu = {
                    text: '<span id="question" class="glyphicons glyphicons-question-sign menu-action" title="Help menu"></span>',
                    encoded: false,
                    items: []
                };

                service.fillHelpMenuItems(menu.items, account);
                return menu;
            };

            service.getQuickLinksMenuSuccessCallback = function (resultQuickLinks, response) {
                var quickLinks = response.data;
                if (quickLinks) {
                    angular.forEach(quickLinks, function iterator(value) {
                        var url = UrlService.createAbsoluteUrl(value.url);
                        resultQuickLinks.push({
                            text: service.capitalize(value.labelText),
                            url: url,
                            encoded: false
                        });
                    });
                }
            };

            service.getQuickLinksMenu = function () {
                var resultQuickLinks = [];
                var req = {
                    method: 'GET',
                    url: UrlService.createAbsoluteUrl('/rest/currentAccount/quickLinks')
                };

                $http(req).then(function successfulCallback(response) {
                        service.getQuickLinksMenuSuccessCallback(resultQuickLinks, response);
                    },
                    function errorCallback(response) {
                        NotificationService.showErrorMessage(response.data);
                    }
                );

                return {
                    text: '<span class="glyphicons glyphicons-pushpin menu-action" title="Quick links"></span>',
                    encoded: false,
                    items: resultQuickLinks
                };
            };

            service.getCurrentAccount = function getCurrentAccount(successCallback) {
                if (!service.currentAccountPromise) {
                    service.currentAccountPromise = $http.get(UrlService.createAbsoluteUrl('/rest/currentAccount'));
                }
                return service.currentAccountPromise
                    .then(function successCallbackWrapper(response) {
                        service.currentAccountPromise.resolved = true;
                        successCallback(response.data);
                    }, NotificationService.showValidationErrors);
            };

            service.updateBasketBadge = function (basketSize, netTotalValue) {
                service.getCurrentAccount(function callback(currentAccount) {
                    currentAccount.basketSize = basketSize;
                    currentAccount.basketNetTotal.value = netTotalValue;
                });
            };

            function determineFileTypeIcon(type) {
                switch (type) {
                    case 'application/pdf':
                        return 'far fa-file-pdf';
                    default:
                        return null;
                }
            }
        }]);


/***/ }),

/***/ 39:
/***/ (function(module, exports) {

angular.module('appMarketplace')
    .service('OrderService', ['$q', '$http', '$window', 'UrlService', 'CommonService', 'NotificationService',
                             function ($q, $http, $window, UrlService, CommonService, NotificationService) {
        var service = this;

        service.addItemToOrder = function (item, documentId, successCallback, errorCallback) {
            service.addItemsToOrder([item], documentId, successCallback, errorCallback);
        };

        service.addItemsToOrder = function (items, documentId, successCallback, errorCallback) {
            var products = [];
            angular.forEach(items, function iterator(item) {
                products.push({
                    id: item.id,
                    clin: item.clin,
                    quantity: item.quantity,
                    vendorId: item.vendorId,
                    fieldId: item.fieldId
                });
            });

            var req = {
                method: 'POST',
                url: UrlService.createAbsoluteUrl('/rest/order/' + documentId + '/items'),
                data: products
            };

            $http(req).then(function successCallbackWrapper(response) {
                var basketActionResult = response.data;
                successCallback(basketActionResult);
            }, function errorCallbackWrapper(response) {
                errorCallback(response.data)
            })
        };

        service.getDetails = function (documentId, successCallback, errorCallback) {
            var req = {
                method: 'GET',
                url: UrlService.createAbsoluteUrl('/rest/order/' + documentId)
            };

            return $http(req).then(function successCallbackWrapper(response) {
                return successCallback(response.data);
            }, function errorCallbackWrapper(response) {
                return errorCallback(response.data);
            })
        };

        service.getOrderDetails = function (documentId) {
            var promise;
            if (documentId) {
                CommonService.showProgressPanel();
                promise = service.getDetails(documentId,
                    function successCallback(orderDetails) {
                        CommonService.hideProgressPanel();
                        return orderDetails;
                    }, function errorCallback(responseError) {
                        NotificationService.showValidationErrors(responseError);
                        CommonService.hideProgressPanel();
                        return $q.reject();
                    });
            } else {
                var deferred = $q.defer();
                promise = deferred.promise;
                deferred.resolve(false);
            }
            return promise;
        };

        service.goBackToOrder = function (documentId) {
            $window.location.href = UrlService.createAbsoluteUrl('/order/order_redirect.jsp?DocumentId=' + documentId);
        };
    }]);

/***/ }),

/***/ 496:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(46);
__webpack_require__(272);
__webpack_require__(205);
__webpack_require__(236);
__webpack_require__(269);
__webpack_require__(189);
__webpack_require__(39);
__webpack_require__(201);
__webpack_require__(69);


/***/ }),

/***/ 69:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

angular.module('appMarketplace')
    .service('AppInsightsConfigService', ['$http', 'UrlService', function ($http, UrlService) {
        var service = this;

        service.getAppInsightsConfig = function (successCallback, errorCallback) {
            var req = {
                method: 'GET',
                url: UrlService.createAbsoluteUrl('/rest/app-insights')
            };

            return $http(req).then(function successCallbackWrapper(response) {
                successCallback(response.data);
            }, function errorCallbackWrapper(response) {
                errorCallback(response.data);
            });
        };

        service.saveAppInsightsProperty = function (appInsightsProperty, successCallback, errorCallback) {
            var req = {
                method: 'POST',
                url: UrlService.createAbsoluteUrl('/rest/app-insights'),
                data: {
                        "key": appInsightsProperty.key,
                        "value": appInsightsProperty.value,
                        "description": appInsightsProperty.description
                }
            };

            return $http(req).then(function successCallbackWrapper(response) {
                successCallback(appInsightsProperty);
            }, function errorCallbackWrapper(response) {
                errorCallback(response.data);
            });
        };

        service.deleteAppInsightsProperty = function (key, successCallback, errorCallback) {
            var req = {
                method: 'DELETE',
                url: UrlService.createAbsoluteUrl('/rest/app-insights/' + key)
            };

            $http(req).then(function (response) {
                successCallback();
            }, function () {
                errorCallback();
            })
        };
    }]);

/***/ })

},[496]);


// WEBPACK FOOTER //
// headerEntry.js?ver=92639f712d444b087f9e